import { FC, Fragment, type JSX } from 'react';

import ContentPanel from '@payaca/components/contentPanel/ContentPanel';

import { LineItemGroup } from '@payaca/types/lineItemGroupTypes';

import UntitledIcon from '@payaca/untitled-icons';
import './ListedItemGroupControl.css';

type Props = {
  itemGroup?: LineItemGroup;
  onClick: () => void;
  onArchiveItemGroup?: (itemGroupId: number) => void;
};
const ListedItemGroupControl: FC<Props> = ({
  itemGroup,
  onClick,
}: Props): JSX.Element => {
  return (
    <ContentPanel className="listed-item-group-control">
      <div
        className={`listed-item-group-control-inner${
          itemGroup ? '' : ' add-group'
        }`}
        onClick={onClick}
      >
        {itemGroup ? (
          <Fragment>
            <span className="font-bold group-name">
              {itemGroup.name || 'Unnamed group'}
            </span>
            <div className="listed-item-group-control-name-description">
              <span className="group-description">{itemGroup.description}</span>
            </div>

            <div className="icon-wrapper">
              <UntitledIcon name="chevron-right" />
            </div>
          </Fragment>
        ) : (
          <Fragment>
            <span className="font-bold add-group-name">Add new group</span>
            <div className="icon-wrapper">
              <UntitledIcon name="plus.3" />
            </div>
          </Fragment>
        )}
      </div>
    </ContentPanel>
  );
};

export default ListedItemGroupControl;
